import * as React from 'react';
import {FunctionComponent} from 'react';
import windows from 'operating-system-logos/src/32x32/windows.png';
import linux from 'operating-system-logos/src/32x32/linux.png';
import ios from 'operating-system-logos/src/32x32/IOS.png';
import mac from '../assets/mac.png';
import android from 'operating-system-logos/src/32x32/android.png';
import chromeos from 'operating-system-logos/src/32x32/chrome-os.png';
import ubuntu from 'operating-system-logos/src/32x32/ubuntu.png';
import tizen from 'operating-system-logos/src/32x32/tizen.png';

const operatingSystemLogos: OperatingSystemLogos = {
    windows: windows,
    linux: linux,
    ios: ios,
    mac: mac,
    macosx: mac,
    android: android,
    chromeos: chromeos,
    chrome: chromeos,
    ubuntu: ubuntu,
    tizen: tizen,
};

export interface operatingSystemLogoProps {
    name?: string | null | undefined;
    className?: string | undefined;
}

interface OperatingSystemLogos {
    [key: string]: string | undefined
}

function operatingSystemLogo(name: string): any {
    name = name.toLowerCase().replace(/\s/g, '');
    return operatingSystemLogos[name];
}


export const OperatingSystemLogo: FunctionComponent<operatingSystemLogoProps> = ({name, className}) => {
    if (!name) {
        return <span className={className}>Unknown</span>;
    }
    const logo = operatingSystemLogo(name);

    return logo ? <img style={{bottom: 2}} src={logo} className={className} alt={name} title={name}/> : <span className={className}>{name}</span>;
};
